import React from 'react'
import { SimpleForm, useEditController, useTranslate, BooleanInput } from 'react-admin'
import { Grid } from '@mui/material'
import { EditBase } from '../../components/base'
import { FormBottomToolbarWithPermission } from '../../components/form'
import { HERO_BANNERS_FIELDS, COMMON_FIELDS } from '../../providers/localization/constant'
import { ImageMobileInput } from '../../components/inputs/ImageMobileInput'
import { ImageDesktopInput } from '../../components/inputs/ImageDesktopInput'

const HeroBannerEdit = (props): JSX.Element => {
  const translate = useTranslate()
  // return <span>d</span>

  const { record } = useEditController(props)
  return (
    <EditBase
      // title={`${RESOURCE_PREFIX}.title`}
      encType='multipart/form-data'
      redirect='list'
      listAction={{
        hasShow: false,
        hasBackButton: true,
      }}
    >
      <SimpleForm
        record={{ ...record, encType: 'multipart/form-data' }}
        toolbar={
          <FormBottomToolbarWithPermission encType='multipart/form-data' hasConfirm={true} />
        }
      >
        <Grid item>
            <BooleanInput
              color='primary'
              source='is_active'
              label={`${COMMON_FIELDS}.status.label`}
            />
          </Grid>
        <Grid container spacing={2} alignItems='flex-start' justifyContent='center'>
          <Grid item xs={12} sm={6}>
            <ImageDesktopInput
              label={translate(`${HERO_BANNERS_FIELDS}.image_desktop`)}
              initCrop={false}
              fallbackSource='full_path'
              source='image_desktop'
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <ImageMobileInput
              label={translate(`${HERO_BANNERS_FIELDS}.image_mobile`)}
              initCrop={false}
              fallbackSource='full_path'
              source='image_mobile'
            />
          </Grid>
        </Grid>
      </SimpleForm>
    </EditBase>
  )
}

export default HeroBannerEdit
